/**
 * Provides standardized CourseIcon component that maps from a name prop to SVG icon.
 * Most icons are sourced from Heroicons v1/v2 and re-exported here.
 */

import React from 'react';
import cx from 'classnames';

import {
  AcademicCapIcon,
  BookOpenIcon,
  CheckBadgeIcon,
  CircleStackIcon,
  ClockIcon,
  CodeBracketSquareIcon,
  CubeIcon,
  LockClosedIcon,
  PlayCircleIcon,
  PuzzlePieceIcon,
} from '@heroicons/react-v2/24/outline';
import {
  AcademicCapIcon as AcademicCapIconSolid,
  BookOpenIcon as BookOpenIconSolid,
  CheckBadgeIcon as CheckBadgeIconSolid,
  CircleStackIcon as CircleStackIconSolid,
  ClockIcon as ClockIconSolid,
  CodeBracketSquareIcon as CodeBracketSquareIconSolid,
  CubeIcon as CubeIconSolid,
  LockClosedIcon as LockClosedIconSolid,
  PlayCircleIcon as PlayCircleIconSolid,
  PuzzlePieceIcon as PuzzlePieceIconSolid,
} from '@heroicons/react-v2/24/solid';

// Registry of names to icons for usage in the CMS
export const IconMapping = {
  badge: {
    outline: CheckBadgeIcon,
    solid: CheckBadgeIconSolid,
  },
  book: {
    outline: BookOpenIcon,
    solid: BookOpenIconSolid,
  },
  cap: {
    outline: AcademicCapIcon,
    solid: AcademicCapIconSolid,
  },
  clock: {
    outline: ClockIcon,
    solid: ClockIconSolid,
  },
  code: {
    outline: CodeBracketSquareIcon,
    solid: CodeBracketSquareIconSolid,
  },
  cube: {
    outline: CubeIcon,
    solid: CubeIconSolid,
  },
  database: {
    outline: CircleStackIcon,
    solid: CircleStackIconSolid,
  },
  lock: {
    outline: LockClosedIcon,
    solid: LockClosedIconSolid,
  },
  play: {
    outline: PlayCircleIcon,
    solid: PlayCircleIconSolid,
  },
  puzzle: {
    outline: PuzzlePieceIcon,
    solid: PuzzlePieceIconSolid,
  },
};

export const CourseIcon = ({
  name,
  type = 'solid',
  className,
  ...props
}) => {
  const Icon = IconMapping[name]?.[type];
  return Icon
    ? <Icon className={cx('h-5 w-5', className)} {...props} />
    : <span />;
};
